<template>
    <div
        v-if="data"
        class="layout cutawayLayout"
    >
        <div
            ref="selectParent"
            class="custom-select item-menu"
            :tabindex="0"
            @blur="closeSelect()"
        >
            <div
                class="selected"
                :class="{ 'open active': selectOpen }"
                @click="openSelect()"
                ref="selectDocumentation"
                :style="{ width: selectWidth + 'px' }"
            >
                <span class="icon icon-documentation"/>
                <span class="nav-text">
                    {{ $t("sidebar.elementList") }}
                </span>
                <span
                    class="arrow-icon"
                    :class="{ open: selectOpen }"
                >
                    <span class="left-bar"/>
                    <span class="right-bar"/>
                </span>
            </div>
            <transition name="slidedown">
                <div
                    v-show="selectOpen"
                    class="items"
                    ref="selectBot"
                >
                    <div
                        v-for="(item, index) of data.documents"
                        :key="`document-${index}`"
                        class="item"
                        :class="{'active': !!item.active}"
                        @click="setDocument(index); closeSelect()"
                    >
                        <span class="nav-text">
                            {{ item.name }}
                        </span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'DocumentationLayout',
        props: [
            'data',
        ],
        data() {
            return ({
                selected: [],
                selectWidth: {},
                selectOpen: false,
                displaySelect : true
            });
        },
        methods: {
            getMaxWidth() {
                for (let id in this.$refs) {
                    if (id.includes('select')) {
                        this.$refs[id][1].style.display = 'block';
                        let topWidth = this.$refs[id][0].clientWidth;
                        let botWidth = this.$refs[id][1].clientWidth;
                        this.$refs[id][1].style.display = 'none';
                        this.$set(this.selectWidth, id, topWidth > botWidth ? topWidth : botWidth);
                    }
                }
            },
            openSelect(index) {
                this.selectOpen = !this.selectOpen;
                let mobile = window.matchMedia("(max-width: 515px)");
                if (mobile.matches) {
                    this.setDisplayState(this.selectOpen);
                    if (!this.selectOpen)
                        this.closeSelect();
                    else
                        this.$refs['selectParent'].style.flex = 1;
                }
            },
            closeSelect() {
                this.$refs['selectParent'].style.flex = null;
                if (this.selectOpen) {
                    this.selectOpen = false;
                    this.setDisplayState(this.selectOpen);
                }
            },
            setDisplayState(visible) {
                this.$refs['selectParent'].style.display = visible ? 'none' : null;
            },
            setDocument(index) {
                let localData = _.cloneDeep(this.data);
                localData.documents.filter(el => el.active).forEach(el => el.active = false);
                localData.documents[index].active = true;
                let activeDocument = localData.documents.filter(document => document.active === true)[0];
                EventBus.$emit('updateSidebar', localData, false);
                EventBus.$emit('updateDocumentSource', activeDocument.link);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/navbarLayout/alternativeMenu/DocumentationLayout.vue